import React from 'react';

export default class Loading extends React.Component {
  render() {
    return (
      <div className="full-page main-loader">
        <div className="loader-lg" />
      </div>
    );
  }
}
